import { stylesheet } from 'typestyle';
import {
  flexRoot,
  layerParent,
  newLayer,
  horizontal,
  centerCenter
} from 'csstips';
import { borderGrayOutline, regularYellowText } from '@styles/general';

export default stylesheet({
  container: {
    textAlign: 'center',
    order: -1,
    position: 'relative',

    $nest: {
      '&.video.zoom': {
        $nest: {
          '@media (min-width: 680px)': {
            height: 575,
            margin: -100
          }
        }
      },

      '&:not(.video).zoom [class*=imageContainer_] img': {
        maxWidth: 'none',
        width: 'auto !important',
        position: 'absolute'
      },

      '.product-detail--container.combo-ring &': {
        '@media (max-width: 679px)': {
          marginTop: 40
        }
      }
    }
  },
  squareContainer: {
    ...layerParent,

    width: '100%',
    paddingTop: '100%',
    zIndex: 3
  },
  imageContainer: {
    ...newLayer,
    ...horizontal,
    ...centerCenter,

    border: `1px solid ${borderGrayOutline}`,
    overflow: 'hidden',
    background: 'white',
    zIndex: 1,

    video: {
      width: '100%',
      height: '100%'
    }
  },
  zoomButton: {
    ...flexRoot,
    ...centerCenter,

    position: 'absolute',
    right: 0,
    bottom: 0,
    background: regularYellowText,
    height: 26,
    width: 26,
    zIndex: 1,

    svg: {
      fill: 'white',
      height: 20,
      width: 20
    },

    $nest: {
      '@media (max-width: 679px)': {
        '&': {
          display: 'none'
        }
      }
    }
  },
  favoriteLink: {
    position: 'absolute',
    bottom: 2,
    right: 2,
    zIndex: 4,
    transition: 'none'
  }
});
